// extracted by mini-css-extract-plugin
export default {"page":"pagination_page__jvXNK"};